const MUST_CHANGE_PASSWORD_KEYS = [
  'must_change_password',
  'password_must_be_changed',
  'requires_password_change',
  'force_password_change',
] as const

function isTruthyFlag(value: unknown): boolean {
  return value === true || value === 1 || value === '1' || value === 'true'
}

function readFlagFromRecord(record: Record<string, unknown> | null | undefined): boolean {
  if (!record) return false
  return MUST_CHANGE_PASSWORD_KEYS.some((key) => isTruthyFlag(record[key]))
}

/** Detect whether the API requires a password change before full portal access. */
export function readMustChangePassword(data: unknown): boolean {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return false

  const root = data as Record<string, unknown>
  if (readFlagFromRecord(root)) return true

  const userContext = root.user_context
  if (userContext && typeof userContext === 'object' && !Array.isArray(userContext)) {
    if (readFlagFromRecord(userContext as Record<string, unknown>)) return true
  }

  const user = root.user
  if (user && typeof user === 'object' && !Array.isArray(user)) {
    if (readFlagFromRecord(user as Record<string, unknown>)) return true
  }

  const contractor = root.contractor ?? root.client
  if (contractor && typeof contractor === 'object' && !Array.isArray(contractor)) {
    const contractorRecord = contractor as Record<string, unknown>
    if (readFlagFromRecord(contractorRecord)) return true

    const contractorUser = contractorRecord.user
    if (contractorUser && typeof contractorUser === 'object' && !Array.isArray(contractorUser)) {
      if (readFlagFromRecord(contractorUser as Record<string, unknown>)) return true
    }
  }

  return false
}
